export interface EntraIdConfig {
  clientId: string;
  authority: string;
  redirectUri?: string;
  loginType?: LoginType;
  logoutType?: LogoutType;
}

export type LoginType = LOGIN_TYPE.REDIRECT | LOGIN_TYPE.POPUP;

export type LogoutType = LOGOUT_TYPE.REDIRECT | LOGOUT_TYPE.POPUP | LOGOUT_TYPE.LOGOUT;

export enum LOGIN_TYPE {
  REDIRECT = 'redirect',
  POPUP = 'popup',
}

export enum LOGOUT_TYPE {
  REDIRECT = 'redirect',
  POPUP = 'popup',
  LOGOUT = 'logout',
}
